import { render, staticRenderFns } from "./klineChart.vue?vue&type=template&id=66025d16&scoped=true&"
import script from "./klineChart.vue?vue&type=script&lang=js&"
export * from "./klineChart.vue?vue&type=script&lang=js&"
import style0 from "./klineChart.vue?vue&type=style&index=0&id=66025d16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66025d16",
  null
  
)

export default component.exports